export enum LegalPersonFormFieldNameEnum {
  FIRST_NAME = "first_name",
  LAST_NAME = "last_name",
  BIRTHDAY = "birthday",
  EMAIL = "email",
  CONTACT = "phone_number",
  POSITION = "position",
  NATIONALITY = "nationality",
  IDENTITY_DOCUMENT = "identity_document",
}

export type LegalPersonFormType = {
  last_name: string | null
  first_name: string | null
  birthday: string | null
  email: string | null
  phone_number: string | null
  nationality: string | null
  identity_document: File | null
  position: string | null
}

export const LegalPersonFormDefaultValues: LegalPersonFormType = {
  last_name: "",
  first_name: "",
  birthday: "2024-01-17",
  email: "",
  phone_number: "",
  nationality: "",
  identity_document: null,
  position: "",
}
